import Assistant from '../../components/ai-assistant-chat/assistant';

import './assistant-internal.scss';

export default function AssistantInternal() {

    return (
        <div className="assistant-internal-container">
            <Assistant aiGroupId={null} />
        </div>
    );
}